import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import Calendar from '@/components/pages/calendar/calendar';
import { ScrollArea } from '@/components/ui/scroll-area';

function CalendarPage() {
  return (
    <div className="h-full w-full">
      <Calendar />
    </div>
  );
}

export default CalendarPage;
